import React, { FC } from 'react';
import { Text } from '@cubeyou-team/hx-react-components';

interface PreWrapTextProps {
  text: string;
}

export const PreWrapText: FC<PreWrapTextProps> = ({ text }) => {
  return (
    <Text
      tag="span"
      size="x_body"
      weight="regular"
      className="whitespace-pre-wrap break-words ml-1"
    >
      {text}
    </Text>
  );
};
